// Module
var code = "<div id=\"appwizard-container\"> <div id=\"appwizard-topbar\" data-test-id=\"appwizard-header\"></div> <div id=\"appwizard-componentwizard\"></div> <div id=\"appwizard-modals\"></div> </div> ";
// Exports
export default code;